import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACompany, loadCompanysData, saveACompany, updateACompany} from "../../redux/modules/company";
import {
	deleteATowCompanyTruck,
	loadTowCompanyTrucksData,
	saveATowCompanyTruck,
	updateATowCompanyTruck,
	clearTowCompanyTruckErrorMsg,
} from "../../redux/modules/towcompanytruck";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import InputMask from 'react-input-mask'

//import {loadCompanysData} from "../../redux/modules/company";


import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardCompanyInformation from "./CardCompanyInformation";
import CardStorageLotInformation from "./CardStorageLotInformation";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as MainConstants from "../../utils/MainConstants";
import ExpandableTowCompanyTruckInformation from "./ExpandableTowCompanyTruckInformation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import {loadLocationsData} from "../../redux/modules/location";


/*const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400, marginLeft: 'auto', marginRight: 'auto',
		},
	}, paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	}, avatar: {
		margin: theme.spacing.unit, backgroundColor: theme.palette.secondary.main,
	}, form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	}, submit: {
		marginTop: theme.spacing.unit * 3,
	}, formControl: {
		margin: theme.spacing.unit, minWidth: 120,
	}, selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	}, button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		color: "black",
		textTransform: "unset !important",
	}, gridList: {
		width: '80%', height: '100%',maxHeight:800
	},
});*/

const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	},
	button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		color: "black",
		textTransform: "unset !important",
		width: '80%'
	},
	gridList: {
		width: '80%',
		height: '100%',
		maxHeight:800,
	},
});


/*
private String id;
	private String ein;
	private String userId;
	private String name;
	private String address1;
	private String address2;
	private String city;
	private String state;
	private String country;
	private String zipCode;
	private String type;
	private String phone;
	private String email;
 */

class TowCompanyTrucksForm extends React.Component {
	
	
	state = {
		
		//selectedLocation:{},
		selectedTowCompanyTruck: {"id":""}, selectedCompany: {}, inputFieldShrinkState: true, numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
		showStoragelotSavedDialog: false
		
	};
	
	
	constructor(props) {
		super(props);
		this.truckDriversCardList = null;
		this.editRecord = this.editRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.refresh = this.refresh.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		//this.handleCompanyNumberChange = this.handleCompanyNumberChange.bind(this);
		this.handleTruckIdChange = this.handleTruckIdChange.bind(this);
		this.handleTruckYearChange = this.handleTruckYearChange.bind(this);
		//this.handleBankNameChange = this.handleBankNameChange.bind(this);
		
		this.handleTruckMakeChange = this.handleTruckMakeChange.bind(this);
		
		
		this.handleTruckModelChange = this.handleTruckModelChange.bind(this);
		this.handleTruckTypeChange = this.handleTruckTypeChange.bind(this);
		
		this.handleCompanyChange = this.handleCompanyChange.bind(this);
		this.getListOfTruckDriversExpandable = this.getListOfTruckDriversExpandable.bind(this);
		
		this.handleClickShowSavedStoragelot = this.handleClickShowSavedStoragelot.bind(this);
		this.handleClickShowSavedStoragelotClose = this.handleClickShowSavedStoragelotClose.bind(this);
		
	}
	
	
	handleClickShowSavedStoragelot() {
		this.setState({showStoragelotSavedDialog: true});
	};
	
	
	handleClickShowSavedStoragelotClose() {
		let {clearTowCompanyTruckErrorMsg} = this.props;
		this.setState({showStoragelotSavedDialog: false});
		clearTowCompanyTruckErrorMsg();
	};
	
	handleSubmit() {
		
		
		let {saveATowCompanyTruck} = this.props;
		
		var tempStream = this.state.selectedTowCompanyTruck;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry
		if ((tempStream.address2 == null) || (tempStream.address2.length == 0)) {
			tempStream.address2 = "  ";
		}
		saveATowCompanyTruck(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		this.refresh();
		
	};
	
	handleUpdate() {
		let {updateATowCompanyTruck} = this.props;
		
		var tempStream = this.state.selectedTowCompanyTruck;
		tempStream.companyid = this.state.selectedCompany.id;
		updateATowCompanyTruck(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		this.refresh();
		
	};
	
	handleTruckModelChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {model: event.target.value}));
	}
	
	handleTruckMakeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {make: event.target.value}));
	}
	
	handleTruckYearChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {year: event.target.value}));
	}
	
	handleTruckIdChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {truckid: event.target.value}));
	}
	
	
	handleTruckTypeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {type: event.target.value}));
	}
	
	handleCompanyChange(event) {
		let {loadTowCompanyTrucksData} = this.props;
		//event.preventDefault();
		this.setState({selectedCompany: event.target.value});
		loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		this.setState({numberShrink: true});
	}
	
	handleTypeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyTruck, {type: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkState: true
		}));
		
		
		var tempSelectedStorage = Object.assign({}, this.state.selectedTowCompanyTruck);
		Object.keys(tempSelectedStorage).map((key, index) => {
			tempSelectedStorage[key] = "";
		});
		this.setState({selectedTowCompanyTruck: tempSelectedStorage})
	};
	
	renderErrorFiled(data) {
	
	
	}
	
	refresh(event) {
		let {loadTowCompanyTrucksData} = this.props;
		loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	getListOfStoragelots() {
		let tempArray = this.props.towcompanytrucksArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				return (< CardStorageLotInformation
					info={s}
					onEdit={this.editRecord}
					onDelete={this.deleteRecord(s.id)}> < /CardStorageLotInformation>);
			});
		}
		return (returnArray);
	}
	
	
	getListOfTruckDriversExpandable() {
		let tempArray = this.state.towcompanytrucksArray; //this.props.towjobsArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				
				return (
					
					<ExpandableTowCompanyTruckInformation info={s} key={s.id} onEdit={this.editRecord}
				                                              onVehicleOwnerText={this.vehicleOwnerTextMode}
				                                              onTowAgentText={this.towAgentTextMode}
				                                              onDelete={this.deleteRecord}>
						
					</ExpandableTowCompanyTruckInformation>
					 
					 );
			});
			//Duplicating array for testing only.
			//returnArray = returnArray.concat(returnArray);
			
		}
		return (returnArray);
	}
	
	getListOfCompaniesForSelection() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (< MenuItem
					key={s.id}
					value={s}> {s.name} < /MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return (returnArray);
	}
	
	
	render() {
		const {classes} = this.props;
		let usStates = MainConstants.getUSStates();
		let canStates = MainConstants.getCanadaStates();
		let availableCountries = MainConstants.getCountries();
		this.truckDriversCardList = this.getListOfTruckDriversExpandable();//this.getListOfStoragelots();
		this.companySelectList = this.getListOfCompaniesForSelection();
		return (< React.Fragment>
				< Typography
					variant="h6"
					gutterBottom>
					Storage
					Lot
					Information
				< /Typography>
				< Grid container spacing={24}>
					< Grid item xs={12} sm={12}>
						
						< Grid container>
							
							< Grid item xs={6} sm={6}>
								
								
								<Grid container>
									< Grid item xs={5} sm={5}>
										< TextField
											required
											id="truckid"
											name="truckid"
											label="Truck Id"
											fullWidth
											InputLabelProps={{
												shrink: this.state.inputFieldShrinkState
											}}
											value={this.state.selectedTowCompanyTruck.truckid}
											onChange={this.handleTruckIdChange}
										/>
									< /Grid>
									< Grid item xs={2} sm={2}>
									< /Grid>
									< Grid item xs={5} sm={5}>
										< FormControl
											className={classes.formControl}>
											< InputLabel
												htmlFor="age-helper"> Select Tow Company < /InputLabel>
											< Select
												value={this.state.selectedCompany}
												onChange={this.handleCompanyChange}
												useDefault={true}
												defaultValue={this.state.selectedCompany.name}
											>
												
												{this.companySelectList}
											
											</Select>
											{/*   < FormHelperText > Select
        a
        Company < /FormHelperText>
        */}
										< /FormControl>
									< /Grid>
								< /Grid>
								
								< Grid item xs={12}>
									< TextField
										required
										id="year"
										name="year"
										label="Year"
										fullWidth
										InputLabelProps={{
											shrink: this.state.inputFieldShrinkState
										}}
										value={this.state.selectedTowCompanyTruck.year}
										onChange={this.handleTruckYearChange}
									/>
								< /Grid>
								
								< Grid item xs={12}>
									< TextField
										id="make"
										name="make"
										label="Make"
										fullWidth
										InputLabelProps={{
											shrink: this.state.inputFieldShrinkState
										}}
										value={this.state.selectedTowCompanyTruck.make}
										onChange={this.handleTruckMakeChange}
									/>
								< /Grid>
								< Grid container>
									< Grid item xs={12} sm={12}>
										< TextField required id="model" name="model" label="Model"
										            fullWidth
										            InputLabelProps={{
											            shrink: this.state.inputFieldShrinkState
										            }}
										            value={this.state.selectedTowCompanyTruck.model}
										            onChange={this.handleTruckModelChange}
										/>
									< /Grid>
									
									
									<Grid item xs={12} sm={12}>
										<TextField required id="type" name="type" type="type" label="Type" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedTowCompanyTruck.type} onChange={this.handleTruckTypeChange}/>
									</Grid>
									
									
									<Grid item xs={5} sm={5}>
									
									</Grid>
									< Grid item xs={2} sm={2}>
									< /Grid>
									
									< Grid item xs={5} sm={5}>
									< /Grid>
									
									
									< Grid item xs={5} sm={5}>
									< /Grid>
									< Grid item xs={2} sm={2}>
									< /Grid>
									
									< Grid item xs={5} sm={5}>
									
									< /Grid>
									
									
									< Grid item xs={5} sm={5}>
									< /Grid>
									< Grid item xs={2} sm={2}>
									< /Grid>
									
									< Grid item xs={5} sm={5}>
									< /Grid>
									
									< Grid item xs={5} sm={5}>
									< /Grid>
									< Grid item xs={2} sm={2}>
									< /Grid>
									
									< Grid item xs={5} sm={5}>
										{/* empty for now we can later*/}
									< /Grid>
									
									
									< Grid
										item
										xs={6}
										sm={6}>
										{((this.state.selectedTowCompanyTruck.id === undefined) || (this.state.selectedTowCompanyTruck.id === "")) && (
										< Button
											variant="contained"
											color="primary"
											onClick={this.handleSubmit}
											className={classes.button}>
											Add
											Truck
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										{(  (this.state.selectedTowCompanyTruck.id !=='')) && (
										< Button
											variant="contained"
											color="primary"
											onClick={this.handleUpdate}
											className={classes.button}>
											Update Truck
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.clearFields}
											className={classes.button}>
											Clear
											Fields
										< /Button>
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.refresh}
											className={classes.button}>
											Refresh
										< /Button>
									< /Grid>
								< /Grid>
							< /Grid>
							< Grid
								item
								xs={1}
								sm={1}>
							< /Grid>
							< Grid
								item
								xs={5}
								sm={5}>
								{/*<DynamicTable  data={this.props.companysArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
								<Typography variant="h6" gutterBottom>
									There are {this.props.towcompanytrucksArray.length} Trucks in your profile.
								</Typography>
								
								< GridList
									cellHeight={100}
									className={classes.gridList}>
									{this.truckDriversCardList}
								< /GridList>
							< /Grid>
						< /Grid>
						
						
						< Grid container>
							{(this.props.errorCMsg) && (this.props.errorCMsg.message) && (< Grid
								item
								xs={12}>
								< TextField
									error
									id="outlined-error"
									label="Error - Operation Failed"
									value={" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " + this.props.errorCMsg.timestamp}
									className={classes.textField}
									margin="normal"
									variant="outlined"
									disabled={true}
									multiline={true}
								/>
							< /Grid>)}
						
						</Grid>
					< /Grid>
					
					{/* This is for submit event error/success display */}
					<Dialog
						open={this.state.showStoragelotSavedDialog}
						onClose={this.handleClickShowSavedStoragelotClose}
						scroll={'paper'}
						classes={{
							paper: classes.formControl2,
						}}
						aria-labelledby="scroll-dialog-title"
						aria-describedby="scroll-dialog-description"
						maxWidth="xl"
					>
						<DialogTitle id="scroll-dialog-title">Truck Information</DialogTitle>
						<DialogContent id="farshids" dividers="paper">
							
							{(this.props.errorCMsg.status == 200) && (<div>
								The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button
								- {this.props.errorCMsg.status} {this.props.errorCMsg.statusText}
							</div>)}
							{(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
								The Operation FAILED, please try again!
								- {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
							</div>)}
						
						</DialogContent>
						<DialogActions>
							{/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
							
							<Button onClick={this.handleClickShowSavedStoragelotClose} color="secondary">Close</Button>
						</DialogActions>
					</Dialog>
				< /Grid>
			< /React.Fragment>);
	}//end of render
	
	
	editRecord(singleRowData) {
		this.setState({inputFieldShrinkState: true});
		this.setState({selectedTowCompanyTruck: singleRowData});
	}
	
	
	deleteRecord(argProcessId) {
		//alert('I am deleting ' + argCameraId);
		let {deleteATowCompanyTruck, loadTowCompanyTrucksData} = this.props;
		deleteATowCompanyTruck(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id, argProcessId);
		loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	
	componentWillMount() {
		let {loadTowCompanyTrucksData, loadCompanysData} = this.props;
		//loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url);
		//loadLocationsData("http://localhost:9065/" );
		
		loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
		
		this.setState({
			errorCMsg: {}
		});
		
		//this.setState({selectedCompany: event.target.value});
		//loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		
		if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
			this.setState({selectedCompany: this.props.companysArray[0]});
			loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, this.props.companysArray[0].id);
		}
	}
	
	componentDidMount() {
		/*if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
				this.setState({selectedCompany: this.props.companysArray[0]});
		}*/
		
	}
	
	componentWillReceiveProps(nextProps) {
		if (this.props.towcompanytrucksArray !== nextProps.towcompanytrucksArray) {
			this.setState({
				towcompanytrucksArray: nextProps.towcompanytrucksArray
			});
		}
		if ((nextProps != null) && (nextProps.companysArray != null) && (nextProps.companysArray.length >= 1) && (this.props.companysArray !== nextProps.companysArray)) {
			this.setState({selectedCompany: nextProps.companysArray[0]});
			//selectACompany(nextProps.companysArray[0].id);
		}
		if (nextProps.errorCMsg.status != null) {
			if (nextProps.errorCMsg.status != null) {
				this.handleClickShowSavedStoragelot();
			}
		}
	}
	
	
}//end of class

TowCompanyTrucksForm.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		towcompanytrucksArray: state.towcompanytruck.towcompanytrucksArray,
		truckTowDeleteResponse: state.towcompanytruck.deleteTowCompanyTruckResp,
		truckTowSaveResponse: state.towcompanytruck.saveTowCompanyTruckResp,
		companysArray: state.company.companysArray, //locationsArray:state.location.locationsArray,
		//vcArray:state.videocontroller.vcArray,
		//camerasArray:state.camera.camerasArray,
		errorCMsg: state.towcompanytruck.errorCMsg,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadTowCompanyTrucksData: loadTowCompanyTrucksData,
		deleteATowCompanyTruck: deleteATowCompanyTruck,
		saveATowCompanyTruck: saveATowCompanyTruck,
		updateATowCompanyTruck: updateATowCompanyTruck,
		loadCompanysData: loadCompanysData,
		clearTowCompanyTruckErrorMsg: clearTowCompanyTruckErrorMsg,
		
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TowCompanyTrucksForm));
